import { RootState } from '@/App/store';

export const selectSeoMetas = (state: RootState) => state.config.seo.metas;
